import { Component, OnInit, AfterViewInit } from "@angular/core";
import { SchoolService } from "../../../../shared/services/school.service";
import { DistrictAdministrationService } from "../../services/districtadministration.service";
import { Router, ActivatedRoute } from "@angular/router";
import { UserService } from "../../../../shared/services/user.service";
import { HttpclientService } from "../../../../shared/services/httpclient.service";
import { Subscription } from "rxjs";
//import { LazyLoadEvent } from 'primeng/api';

@Component({
	templateUrl: "./addemail.component.html",
})
export class AddEmailComponent {
	constructor(
		private schoolService: SchoolService,
		private router: Router,
		private route: ActivatedRoute,
		private userService: UserService,
		private districtAdministrationService: DistrictAdministrationService
	) {}

	schoolList: any = [];
	subscription: Subscription;
	user: any;
	email: any = {
		EMailSMSProviderName: "",
		EmailSMSProviderEmailInfo: "",
	};
	isProcessing: any = false;

	SaveErrorMessage = "";

	EMailSMSProviderID = "";
	// EMailSMSProviderName="";

	//   ngOnInit() {
	//     let id = this.route.snapshot.params["id"];

	//     if (id) {
	//       this.EMailSMSProviderID = id;
	//       var result = this.districtAdministrationService.EmailGet(this.EMailSMSProviderID);
	//       result.subscribe(
	//         (response) => {
	//           this.email = response;
	//         },
	//         (error) => {}
	//       );
	//     }

	//   }

	Cancel() {
		this.router.navigate(["/siteadmin/email"]);
	}
	EmailUpdate() {
		if (!this.email.EmailSMSProviderName) {
			this.SaveErrorMessage = "Select ProviderName";
			return;
		}
		if (!this.email.EmailSMSProviderEmailInfo) {
			this.SaveErrorMessage = "Enter Provider Email";
			return;
		}

		var result = this.districtAdministrationService.SMSEmailInsert(this.email.EmailSMSProviderName, this.email.EmailSMSProviderEmailInfo);

		result.subscribe((response: any) => {
			var res: any = response;
			// if (response) {
			//     this.SaveErrorMessage = response
			// } else {
			this.router.navigate(["/siteadmin/email"]);
		});
	}
}

/*  SaveAcademy() {
    var result = this.adminSetupService.AcademyUpdate(
      this.academy.AcademyID,
      this.academy.AcademyCD,
      this.academy.AcademyDesc,
      this.academy.Director_PersonID
    );

    result.subscribe((response: any) => {
      var res: any = response;

      if (response) {
        this.SaveErrorMessage = response;
      } else {
        this.router.navigate(["/adminsetup/academy"]);
      }
    });
  } */
